import React from 'react';
import { Card, Descriptions, Tag, Spin, Button, Space } from 'antd';
import { ArrowLeftOutlined } from '@ant-design/icons';
import { useNavigate, useParams } from 'react-router-dom';
import dayjs from 'dayjs';
import { useStoreDetail } from '../../hooks/useStores';

const STORE_TYPE_LABEL: Record<number, string> = { 1: 'Tiêu chuẩn', 2: 'Chỉ bạc' };

const StoreDetail: React.FC = () => {
  const { id } = useParams<{ id: string }>();
  const navigate = useNavigate();
  const { store, loading } = useStoreDetail(id || '');

  if (loading) return <Spin size="large" style={{ display: 'block', margin: '40px auto' }} />;
  if (!store) return <Card>Không tìm thấy cửa hàng.</Card>;

  return (
    <Space direction="vertical" size={16} style={{ width: '100%' }}>
      <Button icon={<ArrowLeftOutlined />} onClick={() => navigate('/stores')}>Quay lại</Button>
      <Card title={`Cửa hàng · ${store.name}`}>
        <Descriptions column={2} bordered size="small">
          <Descriptions.Item label="Mã">{store.code}</Descriptions.Item>
          <Descriptions.Item label="Tên">{store.name}</Descriptions.Item>
          <Descriptions.Item label="Địa chỉ" span={2}>{store.address || '—'}</Descriptions.Item>
          <Descriptions.Item label="Địa chỉ đầy đủ" span={2}>{store.full_address || '—'}</Descriptions.Item>
          <Descriptions.Item label="Hotline">{store.hotline || '—'}</Descriptions.Item>
          <Descriptions.Item label="Email">{store.email || '—'}</Descriptions.Item>
          <Descriptions.Item label="Loại"><Tag>{STORE_TYPE_LABEL[store.store_type] || store.store_type}</Tag></Descriptions.Item>
          <Descriptions.Item label="Trạng thái">
            <Tag color={store.state === 1 ? 'success' : 'default'}>
              {store.state === 1 ? 'Hoạt động' : 'Tắt'}
            </Tag>
          </Descriptions.Item>
          <Descriptions.Item label="Giờ làm việc">{store.working_hours || '—'}</Descriptions.Item>
          <Descriptions.Item label="Ngày làm việc">{store.working_days || '—'}</Descriptions.Item>
          <Descriptions.Item label="Tenant ID" span={2}><code>{store.tenant_id || '—'}</code></Descriptions.Item>
          <Descriptions.Item label="Ngày tạo">
            {store.created_at ? dayjs(store.created_at).format('DD/MM/YYYY HH:mm') : '—'}
          </Descriptions.Item>
          <Descriptions.Item label="Cập nhật">
            {store.updated_at ? dayjs(store.updated_at).format('DD/MM/YYYY HH:mm') : '—'}
          </Descriptions.Item>
        </Descriptions>
      </Card>
    </Space>
  );
};

export default StoreDetail;
export { StoreDetail };
